module.exports = __webpack_public_path__ + "img/龙宫女.329720a0.png";